<script>
    import SpaceRepository from '../../repositories/SpaceRepository';
    import moment from '../../modules/moment';

    export default {
        props: {
            spaceId: {
                type: Number,
                default () {
                    return 0;
                },
            }
        },

        data() {
            return {
                page: 2,
                reviews: [],
                states: {
                    loading: false,
                    hasMore: window.YPS.has_more_reviews
                },
            }
        },

        filters: {
            reviewDate(date) {
                return new moment(date).format('Do MMMM YYYY');
            },
        },

        methods: {
            loadMore() {
                this.states.loading = true;

                SpaceRepository.reviews(this.spaceId, {
                    page: this.page++,
                    per_page: window.YPS.reviews_pagination,
                }).then(({ data }) => {
                    this.reviews = this.reviews.concat(data.data);
                    this.states.loading = false;
                    this.states.hasMore = data.meta.pagination.current_page < data.meta.pagination.total_pages;
                }).catch(() => {
                    this.states.loading = false;
                    this.page--;
                });
            },
        }
    }
</script>
